import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const sections = [
  {
    title: "Política de clases",
    items: [
      "Todas las clases se imparten únicamente en línea.",
      "Las clases no son transferibles.",
      "No hay reembolsos una vez iniciado el paquete.",
      "El tiempo máximo de espera es de 10 minutos.",
    ],
  },
  {
    title: "Política de cancelación",
    items: [
      "Las cancelaciones deben realizarse con al menos 12 horas de anticipación.",
      "Las clases no canceladas a tiempo se consideran impartidas.",
    ],
  },
  {
    title: "Política de uso",
    items: [
      "El acceso a las clases es exclusivo para el alumno inscrito.",
      "No está permitido grabar ni distribuir el contenido de las clases.",
    ],
  },
];

const PoliciasPage = () => {
  return (
    <div className="page-shell" data-testid="politicas-page">
      <div className="page-container">
        <Link to="/" className="page-back" data-testid="politicas-back">
          <ArrowLeft size={16} />
          <span>Volver al inicio</span>
        </Link>

        <header className="page-header">
          <h1 className="page-title" data-testid="politicas-title">Políticas</h1>
          <p className="page-lead">
            Estas son las condiciones bajo las cuales operan nuestras clases en
            Laboratorio Secreto. Te recomendamos leerlas con atención.
          </p>
        </header>

        <article className="page-article">
          {sections.map((section, i) => (
            <section key={i} className="page-section">
              <h2 className="page-section-title">{section.title}</h2>
              <ul className="page-list">
                {section.items.map((item, j) => (
                  <li key={j} className="page-list-item">{item}</li>
                ))}
              </ul>
            </section>
          ))}
        </article>

        <footer className="page-footer">
          <Link to="/" className="page-link">← Regresar a la página principal</Link>
        </footer>
      </div>
    </div>
  );
};

export default PoliciasPage;
